import { render } from "./CalendarHistoryIcon.vue?vue&type=template&id=d9d3a766"
import script from "./CalendarHistoryIcon.vue?vue&type=script&lang=js"
export * from "./CalendarHistoryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__